
/**
 * 通用浮点数高精度计算
 * Created by hanchao on 2017/7/23.
 */

/**
 * 高精度加法
 * @param arg1
 * @param arg2
 */

function accAdd (arg1, arg2) {
  var r1, r2, m;
  try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }

  m = Math.max(r1, r2);
  var sum = Number(arg1.toString().movePoint(m)) + Number(arg2.toString().movePoint(m))
  return sum.toString().movePoint(-m);
}

/**
* 高精度减法
* @param arg1
* @param arg2
*/
function accSub (arg1, arg2) {
  var r1, r2, m;
  try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }

  m = Math.max(r1, r2);
  var sum = Number(arg1.toString().movePoint(m)) - Number(arg2.toString().movePoint(m))
  return sum.toString().movePoint(-m);
}

/**
* 高精度乘法
* @param arg1
* @param arg2
*/
function accMul (arg1, arg2) {
  var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try { m += s1.split(".")[1].length } catch (e) { }
  try { m += s2.split(".")[1].length } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

/**
* 高精度除法
* @param arg1
* @param arg2
*/
function accDiv (arg1, arg2) {
  if(!arg1){
    return 0;
  }
  var t1 = 0, t2 = 0, r1, r2;
  try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
  try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
  // with (Math) {
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return (r1 / r2) * Math.pow(10, t2 - t1);
  // }
}

/**
* 左移
* @param nSize
* @param ch
* @returns {string}
*/
String.prototype.padLeft = function (nSize, ch) {
  var len = 0;
  var s = this ? this : "";
  ch = ch ? ch : '0';// 默认补0

  len = s.length;
  while (len < nSize) {
    s = ch + s;
    len++;
  }
  return s;
};

/**
* 右移
* @param nSize
* @param ch
* @returns {string}
*/
String.prototype.padRight = function (nSize, ch) {
  var len = 0;
  var s = this ? this : "";
  ch = ch ? ch : '0';// 默认补0

  len = s.length;
  while (len < nSize) {
    s = s + ch;
    len++;
  }
  return s;
};

/**
* 小数点左移，相当于除以10的scale次方
* @param scale
* @returns {*}
*/
String.prototype.movePointLeft = function (scale) {
  var s, s1, s2, ch, ps, sign;
  ch = '.';
  sign = '';
  s = this ? this : "";

  if (scale <= 0) return s;
  ps = s.split('.');
  s1 = ps[0] ? ps[0] : "";
  s2 = ps[1] ? ps[1] : "";
  if (s1.slice(0, 1) == '-') {
    s1 = s1.slice(1);
    sign = '-';
  }
  if (s1.length <= scale) {
    ch = "0.";
    s1 = s1.padLeft(scale);
  }
  return sign + s1.slice(0, -scale) + ch + s1.slice(-scale) + s2;
};

/**
* 小数点右移，相当于乘以10的scale次方
* @param scale
* @returns {*}
*/
String.prototype.movePointRight = function (scale) {
  var s, s1, s2, ch, ps;
  ch = '.';
  s = this ? this : "";

  if (scale <= 0) return s;
  ps = s.split('.');
  s1 = ps[0] ? ps[0] : "";
  s2 = ps[1] ? ps[1] : "";
  if (s2.length <= scale) {
    ch = '';
    s2 = s2.padRight(scale);
  }
  return s1 + s2.slice(0, scale) + ch + s2.slice(scale, s2.length);
};

/**
* 小数点移位，正数为右移位数，负数则为左移位数
* @param scale
* @returns {*}
*/
String.prototype.movePoint = function (scale) {
  if (scale >= 0)
    return this.movePointRight(scale);
  else
    return this.movePointLeft(-scale);
};
function dateToString (date) {
  var date = new Date(date);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();
  month = month > 9 ? month : ('0' + month);
  day = day > 9 ? day : ('0' + day);
  hour = hour > 9 ? hour : ('0' + hour);
  minute = minute > 9 ? minute : ('0' + minute);
  second = second > 9 ? second : ('0' + second);
  const dateTime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
  return dateTime;
}


export default {
  accAdd: accAdd,
  accSub: accSub,
  accMul: accMul,
  accDiv: accDiv,
  dateToString: dateToString
};



// WEBPACK FOOTER //
// ./src/util/decimal.js